import { withHandlers } from 'recompose';
// Import Utils
import { getEndOfDay, getThirtyDaysAgo } from 'shared-components/src/utils/dates';

export default withHandlers({
  handlePageSizeChange: ({ updatePagination, pagination }) => (
    pageSize,
    pageIndex
  ) => {
    updatePagination({
      ...pagination,
      limit: pageSize,
      offset: pageIndex * pageSize,
    });
  },
  handlePageChange: ({ updatePagination, pagination }) => pageIndex => {
    updatePagination({
      ...pagination,
      page: pageIndex,
      offset: pageIndex * pagination.limit,
    });
  },
  toggleSearchFilter: ({ updateSearchFilter, searchFilter }) => () => {
    updateSearchFilter(!searchFilter);
  },
  resetSearch: ({
    updateParams,
    updateSearchData,
    searchData,
    updateFilterButton,
    updateSearchBy,
    updateSearchFilter,
  }) => () => {
    updateParams({
      name: '',
      status: '',
      amountFrom: '',
      amountTo: '',
      amount: '',
    });
    updateSearchData({
      name: '',
      status: '',
      dateFrom: getThirtyDaysAgo(),
      dateTo: getEndOfDay(),
      amountFrom: '',
      amountTo: '',
      amount: '',
      focusedInput: null,
    });
    updateSearchFilter(false);
    updateFilterButton(false);
    updateSearchBy('');
  },
  updateSearchName: ({
    updateParams,
    updateFilterButton,
    updateSearchFilter,
  }) => e => {
    const { value } = e.target;
    updateParams({
      name: value,
      status: '',
      amountFrom: '',
      amountTo: '',
      amount: '',
    });
    updateFilterButton(false);
    updateSearchFilter(false);
  },
  updateSearchStatus: ({
    updateParams,
    updateFilterButton,
    updateSearchFilter,
  }) => key => {
    updateParams({
      name: '',
      status: key,
      amountFrom: '',
      amountTo: '',
      amount: '',
    });
    updateFilterButton(false);
    updateSearchFilter(false);
  },
  updateSearchAmount: ({
    updateParams,
    updateFilterButton,
    updateSearchFilter,
  }) => key => {
    const value = key.split(/[/]/);
    updateParams({
      name: '',
      status: '',
      amountFrom: value[0],
      amountTo: value[1],
      amount: key,
    });
    updateFilterButton(false);
    updateSearchFilter(false);
  },
  updateSearchByState: ({ updateSearchBy }) => key => {
    updateSearchBy(key);
  },
  searchTransactions: ({
    params,
    searchData,
    updateSearchData,
    updateFilterButton,
    searchBy,
  }) => () => {
    updateSearchData({
      ...searchData,
      name: (params.name.length !== 0 && params.name) || '',
      status: (params.status.length !== 0 && params.status) || '',
      amountFrom: (params.amountFrom.length !== 0 && params.amountFrom) || '',
      amountTo: (params.amountTo.length !== 0 && params.amountTo) || '',
    });

    if (searchBy) return updateFilterButton(true);
  },
});
